import React, { ReactNode } from 'react';

import { Button as AntDButton } from 'antd';
import { ButtonProps } from 'antd/es/button/button';
import styled from 'styled-components';

const StyledGradientBorderButton = styled(AntDButton)`
  box-shadow: 0 0 4px 0 #ff9ac0;
  position: relative;
  z-index: 1;
  border: none;
  overflow: hidden;
  transition:
    color 0.3s,
    background-color 0.3s;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background: linear-gradient(to left, #007aff, #fa7550 50%, #ff5b98);
    border-radius: inherit;
    padding: 1px;
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  .gradient-border-button-content {
    font-size: 12px;
    font-weight: 500;
    background-image: linear-gradient(to left, var(--competitor-purple), #ff5b98);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon {
    color: #ff5b98;
    width: 16px;
    height: 16px;
  }
`;

interface GradientBorderButtonProps extends ButtonProps {
  children: ReactNode;
}

const GradientBorderButton = ({ children, ...props }: GradientBorderButtonProps) => {
  return (
    <StyledGradientBorderButton {...props}>
      <span className="gradient-border-button-content">{children}</span>
    </StyledGradientBorderButton>
  );
};

export default GradientBorderButton;
